import React, { createContext } from 'react';
import { regions } from '../data/regionData';
import { productCategories } from '../data/productCategories';

export const ImkerContext = createContext();

export const ImkerProvider = ({ children }) => {
    // Get locations by category
    const getImkersByCategory = (category) => {
        if (category === "alle") return [];
        if (category === "premium") return [];
        if (category === "bio") return [];
        if (category === "direkt-am-see") return [];
        if (category === "mit-hofladen") return [];
        if (category === "bienenpatenschaft") return [];
        if (category === "mit-kursen") return [];
        return [];
    };

    return (
        <ImkerContext.Provider value={{
            regions,
            productCategories,
            getImkersByCategory
        }}>
            {children}
        </ImkerContext.Provider>
    );
};
